import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconMinus = forwardRef<SVGSVGElement, IconProps>(
  function IconMinus(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-4 h-4 flex-shrink-0 current-color transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 16 16"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M0.689092 9.17438V7.79619L16.2815 7.79619V9.17438L0.689092 9.17438Z" />
      </svg>
    )
  },
)
